import { AnalyticsProvider } from 'contexts/Analytics/Analytics';
import { ApiProvider } from 'contexts/Api/Api';
import { CalculatorProvider } from 'contexts/Calculator/Calculator';
import { ContentProvider } from 'contexts/Content/Content';
import { TooltipProvider } from 'contexts/Tooltip/Tooltip';
import type { AppProps } from 'next/app';
import { initSentry } from 'setup/sentry';
import 'styles/bootstrap.min.css';
import 'styles/index.scss';

initSentry();

export default function App({ Component, pageProps }: AppProps) {
    return (
        <AnalyticsProvider>
            <ApiProvider>
                <ContentProvider>
                    <CalculatorProvider>
                        <TooltipProvider>
                            <Component {...pageProps} />
                        </TooltipProvider>
                    </CalculatorProvider>
                </ContentProvider>
            </ApiProvider>
        </AnalyticsProvider>
    );
}
